module.exports = function() {
  return new Worker(__webpack_public_path__ + "d24baf309cdce4709e3f.worker.js");
};


// WEBPACK FOOTER //
// ./src/models/LocalTelemetry.worker.js